import { ReplyRecommendationCitation } from './ReplyRecommendationCitation';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReplyRecommendationCitationsList = ({
  citationsList
}) => {
  return /*#__PURE__*/_jsx(List, {
    wrapChildren: true,
    children: citationsList.map(citation => {
      return /*#__PURE__*/_jsx(ReplyRecommendationCitation, {
        citation: citation
      }, citation.citationId);
    })
  });
};
ReplyRecommendationCitationsList.displayName = 'ReplyRecommendationCitationsList';